import { getLocalStorage, setLocalStorage } from '@helpers/storage'
import NewInterface from '@images/topbar/promobanners/newInterface.svg'
import { Button, HorizontalBanner, Paragraph, Spreader } from '@ui-kit'
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { NEW_INTERFACE_BANNER } from '../constants'

export const NewInterfaceBanner = () => {
  const { t } = useTranslation()

  const [isClosed, setClosed] = useState(
    !!getLocalStorage(NEW_INTERFACE_BANNER)
  )

  const mainAction = () => {
    window.open(t('topbar.promobanner.new.interface.link'), '_blank')
  }

  const closeAction = () => {
    setLocalStorage(NEW_INTERFACE_BANNER, 'true')
    setClosed(true)
  }

  if (isClosed) {
    return null
  }

  return (
    <HorizontalBanner
      variant='info'
      imageSrc={NewInterface}
      closeAction={closeAction}
      mainAction={mainAction}
      data-testid='new-interface-banner'
    >
      <Paragraph size={12}>
        <Trans i18nKey='topbar.promobanner.new.interface.description' />
      </Paragraph>

      <Spreader spread={10} />

      <Button size={12} variant='text-primary'>
        {t('topbar.promobanner.new.interface.leave.feedback')}
      </Button>
    </HorizontalBanner>
  )
}
